import { all, takeLatest } from 'redux-saga/effects';
import { commonSaga } from './commonSaga';
import { authSaga } from './authSaga';
import { userSaga } from './userSaga';
import { clubSaga } from './clubSaga';
import { eventSaga } from './eventSaga';
import { commonConstants } from '../actions/constants/commonConstant';
import { authConstants } from '../actions/constants/authConstant';
import { userConstants } from '../actions/constants/userConstant';
import { clubConstants } from '../actions/constants/clubConstant';
import { eventConstants } from '../actions/constants/eventConstant';

function* rootSaga() {
        yield all([
                // Common
                takeLatest(commonConstants.carouselImageRequest, commonSaga.getCarouselImages),
                takeLatest(commonConstants.pastEventListRequest, commonSaga.getPastEvents),
                takeLatest(commonConstants.activeEventListRequest, commonSaga.getActiveEvents),
                takeLatest(commonConstants.pastEventListRequest, commonSaga.getUpComingEvents),
                takeLatest(commonConstants.getImagesRequest, commonSaga.getImages),
                takeLatest(commonConstants.getUserLocationRequest, commonSaga.getUserLocation),

                //Auth
                takeLatest(authConstants.userLoginRequest, authSaga.userLogin),
                takeLatest(authConstants.forgotPasswordRequest, authSaga.forgotPassword),
                takeLatest(authConstants.resendMailRequest, authSaga.resendEmail),
                takeLatest(authConstants.forgotPasswordVerifyTokenRequest, authSaga.forgotPasswordVerifyToken),
                takeLatest(authConstants.renewTokenRequest, authSaga.renewToken),
                takeLatest(authConstants.resetPasswordRequest, authSaga.resetPassword),
                takeLatest(authConstants.updatePasswordRequest, authSaga.updatePassword),
                takeLatest(authConstants.userLogoutRequest,authSaga.userLogout),

                //User
                takeLatest(userConstants.getAllUserRequest, userSaga.getAllUsers),
                takeLatest(userConstants.getClubManagersRequest, userSaga.getClubManagers),
                takeLatest(userConstants.createUserRequest, userSaga.createUser),
                takeLatest(userConstants.getRolesRequest, userSaga.getRoles),
                takeLatest(userConstants.getByFilterRequest, userSaga.getByFilter),
                takeLatest(userConstants.RequestedMembersRequest, userSaga.requestedMembers),
                takeLatest(userConstants.getUserRequest, userSaga.getUser),
                takeLatest(userConstants.updateUserRequest, userSaga.updateUser),
                takeLatest(userConstants.deleteUserRequest, userSaga.deleteUser),
                takeLatest(userConstants.getProfileRequest, userSaga.getProfile),
                takeLatest(userConstants.updateProfileRequest, userSaga.updateProfile),

                //clubs
                takeLatest(clubConstants.clubRegisterRequest, clubSaga.clubRegister),
                takeLatest(clubConstants.clubCreateRequest, clubSaga.clubCreate),
                takeLatest(clubConstants.verifyOtpRequest, clubSaga.clubVerifyOTP),
                takeLatest(clubConstants.resendOtpRequest, clubSaga.otpResend),
                takeLatest(clubConstants.getAllClubsRequest, clubSaga.getAllClubs),
                takeLatest(clubConstants.clubGetByFilterRequest, clubSaga.clubGetByFilter),
                takeLatest(clubConstants.getClubRequest, clubSaga.getClub),
                takeLatest(clubConstants.updateClubRequest, clubSaga.updateClub),
                takeLatest(clubConstants.deleteClubRequest, clubSaga.deleteClub),
                takeLatest(clubConstants.getClubByDomainRequest, clubSaga.getClubByDomain),
                takeLatest(clubConstants.memberJoiningRequest, clubSaga.joinMember),
                takeLatest(clubConstants.memberEmailResendRequest, clubSaga.resendEmail),
                takeLatest(clubConstants.getTagsRequest, clubSaga.getTags),
                takeLatest(clubConstants.approveRejectMemberRequest, clubSaga.memberApproveReject),
                takeLatest(clubConstants.memberInvitationRequest, clubSaga.memberInvitation),
                takeLatest(clubConstants.addClubReportRequest, clubSaga.addClubReport),
                takeLatest(clubConstants.clubReportListRequest, clubSaga.clubReportList),

                //Event
                takeLatest(eventConstants.getAllEventsRequest, eventSaga.getAllEvents),
                takeLatest(eventConstants.getActiveEventsRequest, eventSaga.getActiveEvents),
                takeLatest(eventConstants.getUpComingEventsRequest, eventSaga.getUpComingEvents),
                takeLatest(eventConstants.getPastEventsRequest, eventSaga.getPastEvents),
                takeLatest(eventConstants.createEventRequest, eventSaga.createEvent),
                takeLatest(eventConstants.getEventRequest, eventSaga.getEvent),
                takeLatest(eventConstants.updateEventRequest, eventSaga.updateEvent),
                takeLatest(eventConstants.deleteEventRequest, eventSaga.deleteEvent),
                takeLatest(eventConstants.addEventReportRequest, eventSaga.addEventReport),
                takeLatest(eventConstants.getEventReportsRequest, eventSaga.getEventReports),
                takeLatest(eventConstants.getUploadedImagesRequest, eventSaga.getUploadedImages),
                takeLatest(eventConstants.getApprovedImagesRequest, eventSaga.getApprovedImages),
                takeLatest(eventConstants.getRejectedImagesRequest, eventSaga.getRejectedImages),
                takeLatest(eventConstants.imageUploadRequest, eventSaga.imageUpload),
                takeLatest(eventConstants.imageApproveRequest, eventSaga.imageApprove),
                takeLatest(eventConstants.imageRejectRequest, eventSaga.imageReject),
                takeLatest(eventConstants.imageRemoveRequest, eventSaga.imageRemove),
                takeLatest(eventConstants.getByFilterRequest, eventSaga.getByFilterEvent),
                takeLatest(eventConstants.getAllRSVPRequest, eventSaga.getAllRSVPresponse),
                takeLatest(eventConstants.getImagesInteractionRequest, eventSaga.getInteraction),
                takeLatest(eventConstants.createCommentOrReplyRequest, eventSaga.createCommentOrReply),
                takeLatest(eventConstants.removeCommentOrReplyRequest, eventSaga.removeCommentOrReply),
                takeLatest(eventConstants.getCommentListRequest, eventSaga.getAllComments),
                takeLatest(eventConstants.getRepliesListRequest, eventSaga.getAllReplies),
                takeLatest(eventConstants.getReportListRequest, eventSaga.getAllReports),
                takeLatest(eventConstants.userInteractionRequest, eventSaga.userInteraction),
                takeLatest(eventConstants.addReportRequest, eventSaga.addReport),
                takeLatest(eventConstants.addGallertReportRequest, eventSaga.addGalleryReport),
                takeLatest(eventConstants.listGallertReportRequest, eventSaga.galleryReports),
                takeLatest(eventConstants.updateCommentOrReplyRequest, eventSaga.updateCommentOrReply),
                takeLatest(eventConstants.getTextSentimentByMonthRequest, eventSaga.textSentimentByMonth),
                takeLatest(eventConstants.getTextSentimentByStatsRequest, eventSaga.textSentimentByStats),
                takeLatest(eventConstants.getTextSentimentByCategoryRequest, eventSaga.textSentimentByCategory),
                takeLatest(eventConstants.getImageSentimentByMonthRequest, eventSaga.imageSentimentByMonth),
                takeLatest(eventConstants.getImageSentimentByStatsRequest, eventSaga.imageSentimentByStats),
                takeLatest(eventConstants.getImageSentimentByCategoryRequest, eventSaga.imageSentimentByCategory),
                takeLatest(eventConstants.generateMeetingRequest, eventSaga.generateMeeting),
                takeLatest(eventConstants.updateGalleryRequest, eventSaga.updateGallery),
                takeLatest(eventConstants.updateImageSentimentRequest, eventSaga.updateImageSentiment),
                takeLatest(eventConstants.fetchImageRequest, eventSaga.fetchImage),

                //Notification
                takeLatest(userConstants.getUserNotificationRequest, userSaga.getUserNotification),
                takeLatest(userConstants.getNotificationCountRequest, userSaga.getNotificationCount),
                takeLatest(userConstants.categoryChangeRequest, userSaga.categoryChange),
        ]);
}

export default rootSaga;
